<template>
  <div>
    <div class="text-center padding-tb-lg margin-top">
      <router-link to="/featnet" style="color: #bfbfc3">多陪提供技术支持</router-link>
    </div>
  </div>
</template>

<script>


  export default {
    name: 'foot',
    data () {
      return {
      }
    },
    methods: {
    },
    mounted() {
    }
  }
</script>

<style lang="less" scoped>


</style>
